import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlButtonComponent } from '../../sl-button/sl-button.component';

@Component({
  selector: 'sl-modal-header',
  standalone: true,
  imports: [CommonModule, SlButtonComponent],
  templateUrl: './sl-modal-header.component.html',
  styleUrl: './sl-modal-header.component.scss',
})
export class SlModalHeaderComponent {
  @Input() backButton?: boolean;
  @Input() closeButton?: boolean;
  @Input() infoIcon?: boolean;
  @Input() title!: string;
  @Input() subtitle?: string;
  @Output() clickBackEvent = new EventEmitter<void>();
  @Output() clickCloseEvent = new EventEmitter<void>();

  onClickBack() {
    this.clickBackEvent.emit();
  }

  onClickClose() {
    this.clickCloseEvent.emit();
  }

  getAlignment() {
    let alignment = '';
    if (this.backButton) {
      alignment = 'flex-start';
    }

    if (this.infoIcon) {
      alignment = 'center';
    }

    return alignment;
  }
}
